import { OfferStatusInfo } from "../../../../widgets/OfferStatusInfo";
import Unsuccess from "../../../../shared/assets/icons/unsuccess.svg";
import { useAppSelector } from "../../../../shared/store";

export const BanDetail = () => {
  const offerData = useAppSelector((state) => state.payment.offer);

  return (
    <OfferStatusInfo
      iconSrc={Unsuccess}
      isRotate={false}
      title="Вы были заблокированы"
      description="Не можем выдать вам реквизиты для оплаты т.к по вашим данным наблюдается подозрительная активность. Обратитесь в техническую поддержку сайта"
      buttonVariant="primary"
      link={offerData?.goodLink}
      isBtnVisible={!!offerData?.goodLink}
    />
  );
};
